export default {
  supplierInfoList: {
    url: '/supplierInfoList',
    method: 'post'
  },
  registerApprovalList: {
    url: '/sys/set/role/registerApprovalList',
    method: 'post'
  },
  sendBatchMail: {
    url: '/sendBatchMail',
    method: 'post'
  },
  supplierInfoStop: {
    url: '/supplierInfoStop',
    method: 'post'
  },
  editSupplierInfo: {
    url: '/edit',
    method: 'post'
  },
};